import Dexie, { Table } from 'dexie';

export interface CacheItem {
    id?: string;
    result: string;
}

export class AppCache extends Dexie {
    cacheItems!: Table<CacheItem, string>;

    constructor() {
        super('appCache');
        this.version(1).stores({
            cacheItems: 'id, result'
        });
    }

    async insertCacheItem(item: CacheItem) {
        let existing = await this.getCacheItem(item.id);

        if(existing) {
            await this.removeCacheItem(item.id);
        }

        await cache.cacheItems.add(item);
    }

    async getCacheItem(id: string) {
        return await cache.cacheItems.get(id);
    }

    async removeCacheItem(id: string) {
        return await cache.cacheItems.delete(id);
    }
}

export const cache = new AppCache();
